<div class="blank-page">
  <div class="w-full" [ngSwitch]="pageType">
    <p class="mb-4" i18n *ngSwitchCase="'task'">You have no {{ pageType }} assigned.</p>
    <p class="mb-4" i18n *ngSwitchCase="'task-structure' || 'project-structure'">You have no access to {{pageType}}.</p>
    <p class="mb-4" i18n *ngSwitchCase="'asset-basket'">You have no assets in the basket.</p>
    <p class="mb-4" i18n *ngSwitchDefault="">You have no {{ pageType }} available.</p>
  </div>
</div>
